import React, { useEffect, useState } from "react";
import { InputError } from "../../commons/MicroComponents";
import { useDispatch, useSelector } from "react-redux";
// import { loginApiAdmin } from "../../redux/auth/slice";
import RippleLoader from "../../commons/RippleLoader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Eye, EyeSlash } from "iconsax-react";
import { Logo, SignUp } from "../../assets/image";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "./Auth.css";
import { Register } from "../../redux/auth/slice";
import { InputWithLabel } from "../../components/micro";
import { getCountryData } from "../../redux/address/slice";
import ReactSelect from "react-select";
import FromSingpass from "./FromSingpass";

const Auth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const singPassUserString = location?.state?.accessToken;
  const fromSingpass = location?.state?.fromSingpass;

  // Convert string back to JSON (if not already plain string)
  let singPassUser;
  try {
    singPassUser = JSON.parse(singPassUserString);
  } catch (e) {
    singPassUser = singPassUserString; // fallback if it's just a string
  }

  const userSingPassDetails = singPassUser?.data?.data?.original?.data;

  const [loginState, setLoginState] = useState(false);
  // const [showPassword, setShowPassword] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [countryArray, setCountryArray] = useState([]);

  const { countryData, countryLoading } = useSelector((store) => ({
    // Country Data
    countryData: store?.addressData?.getCountryDataStatus?.data,
    countryLoading: store?.addressData?.getCountryDataStatus?.loading,
  }));

  useEffect(() => {
    dispatch(getCountryData());
  }, [dispatch]);

  useEffect(() => {
    if (countryData?.data) {
      let data = countryData?.data?.map((x) => ({
        ...x,
        label: `+ ${x?.phone_code} (${x?.name})`,
      }));
      setCountryArray(data);
    }
  }, [countryData]);

  const validationSchema = Yup.object().shape({
    full_name: Yup.string().required("Please Enter your Full Name"),
    email: Yup.string()
      .email("Invalid Email Address")
      .required("Please Enter your Email"),
    password: Yup.string()
      .required("Please Enter your New Password")
      .min(8, "Password must be at least 8 characters long")
      .matches(/[A-Z]/, "Password must contain at least 1 uppercase letter")
      .matches(/[a-z]/, "Password must contain at least 1 lowercase letter")
      .matches(/[0-9]/, "Password must contain at least 1 number")
      .matches(
        /[^A-Za-z0-9]/,
        "Password must contain at least 1 special character"
      ),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must Match")
      .required("Please Confirm your New Password"),
    countryId: Yup.string().required("Please Select Country"),
    phone: Yup.string()
      .required("Please Enter Mobile")
      .matches(/^\d{8,15}$/, "Mobile number must be 8-15 digits")
      .min(8, "Mobile number must be at least 8 digits")
      .max(15, "Mobile number must be at most 15 digits"),
    dob: Yup.date()
      .nullable()
      .required("Please Select Date Of Birth")
      .test("age", "You must be at least 18 years old", (value) => {
        const today = new Date();
        const birthDate = new Date(value);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }
        return age >= 18;
      }),
    gender: Yup.string().required("Please Select your Gender"),
  });

  const handleRegister = (values) => {
    dispatch(Register(values)).then((res) => {
      setLoginState(false);
      if (res.type === "Register/fulfilled") {
        navigate("/verification-email");
      }
    });
  };

  return (
    <>
      <div className="main snap-x">
        {loginState ? (
          <RippleLoader />
        ) : (
          <div className="center-h">
            <div className="flex w-full flex-col md:justify-start justify-center sm:items-center lg:flex-row">
              {/* sm:text-nowrap text-wrap */}
              <div className="sm:absolute top-3 left-6 w-20 h-20 sm:mx-0 mx-3">
                <img
                  src={Logo}
                  alt="logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <section className="w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
                <div className="max-w-xl md:mx-auto">
                  <div className="main-view">
                    <div className={"mb-8"}>
                      <p className="text-sm opacity-65 mb-2">Welcome!</p>
                      <h1 className="sm:text-2xl text-lg font-ebGaramond font-semibold mb-1">
                        Sign Up Now
                      </h1>
                    </div>
                    {/* Login flow */}
                    <Formik
                      initialValues={{
                        full_name: userSingPassDetails
                          ? userSingPassDetails?.user?.full_name
                          : "",
                        email: userSingPassDetails
                          ? userSingPassDetails?.user?.email
                          : "",
                        password: "",
                        confirm_password: "",
                        countryId: userSingPassDetails
                          ? userSingPassDetails?.user?.country_id
                          : "",
                        country: "",
                        phone: userSingPassDetails
                          ? userSingPassDetails?.user?.phone
                          : "",
                        dob: userSingPassDetails
                          ? userSingPassDetails?.user?.bod
                          : "",
                        gender: userSingPassDetails
                          ? userSingPassDetails?.user?.gender
                          : "",
                        role: "customer",
                        alias_name: userSingPassDetails
                          ? userSingPassDetails?.user?.alias_name
                          : "",
                        country_place_of_birth: userSingPassDetails
                          ? userSingPassDetails?.user?.country_place_of_birth
                          : "",
                        employment_sector: userSingPassDetails
                          ? userSingPassDetails?.user?.employment_sector
                          : "",
                        nric_fin: userSingPassDetails
                          ? userSingPassDetails?.user?.nric_fin
                          : "",
                        openid: userSingPassDetails
                          ? userSingPassDetails?.user?.openid
                          : "",
                        pass_expiry_date: userSingPassDetails
                          ? userSingPassDetails?.user?.pass_expiry_date
                          : "",
                        pass_status: userSingPassDetails
                          ? userSingPassDetails?.user?.pass_status
                          : "",
                        pass_type: userSingPassDetails
                          ? userSingPassDetails?.user?.pass_type
                          : "",
                        passport_expiry_date: userSingPassDetails
                          ? userSingPassDetails?.user?.passport_expiry_date
                          : "",
                        passport_number: userSingPassDetails
                          ? userSingPassDetails?.user?.passport_number
                          : "",
                        principal_name: userSingPassDetails
                          ? userSingPassDetails?.user?.principal_name
                          : "",
                        registered_address: userSingPassDetails
                          ? userSingPassDetails?.user?.registered_address
                          : "",
                        residential_status: userSingPassDetails
                          ? userSingPassDetails?.user?.residential_status
                          : "",
                        sex: userSingPassDetails
                          ? userSingPassDetails?.user?.sex
                          : "",
                      }}
                      validationSchema={validationSchema}
                      onSubmit={(values) => {
                        handleRegister(values);
                        setLoginState(true);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue,
                        handleBlur,
                        handleSubmit,
                      }) => (
                        <Form
                          onSubmit={handleSubmit}
                          className="max-h-[30rem] overflow-y-auto"
                        >
                          <div className="md:space-y-5 space-y-4">
                            <div
                              className={`${
                                fromSingpass && "max-h-[30rem] overflow-y-auto"
                              } md:space-y-5 space-y-4`}
                            >
                              {/* Full Name */}
                              <InputWithLabel
                                className={
                                  errors.full_name && touched.full_name
                                    ? ` input-error `
                                    : ` border `
                                }
                                idFromName="full_name"
                                label="Full Name"
                                type="text"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.full_name}
                                errors={errors.full_name && touched.full_name}
                                errorsText={errors.full_name}
                              />
                              {/* EMail */}
                              <InputWithLabel
                                className={
                                  errors.email && touched.email
                                    ? ` input-error `
                                    : ` border `
                                }
                                idFromName="email"
                                label="Email"
                                type="email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                errors={errors.email && touched.email}
                                errorsText={errors.email}
                              />
                              {/* New Password */}
                              <InputWithLabel
                                className={
                                  errors.password && touched.password
                                    ? ` input-error `
                                    : ` border `
                                }
                                idFromName="password"
                                label="New Password"
                                type={passwordType}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                errors={errors.password && touched.password}
                                errorsText={errors.password}
                                icon={
                                  <p
                                    className="p-2 absolute top-1.5 right-0 rounded bg-transparent z-20"
                                    onClick={() => {
                                      setPasswordType(
                                        passwordType === "password"
                                          ? "text"
                                          : "password"
                                      );
                                    }}
                                  >
                                    {passwordType === "password" ? (
                                      <EyeSlash size="20" />
                                    ) : (
                                      <Eye size="20" />
                                    )}
                                  </p>
                                }
                              />
                              {/* Password Criteria */}
                              <div className="mt-2 p-3 bg-gray-50 rounded-md">
                                <p className="text-sm font-medium text-gray-700 mb-2">
                                  Password must contain:
                                </p>
                                <div className="space-y-1">
                                  <div
                                    className={`flex items-center text-sm ${
                                      values.password &&
                                      values.password.length >= 8
                                        ? "text-green-600"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    <span className="mr-2">
                                      {values.password &&
                                      values.password.length >= 8
                                        ? "✓"
                                        : "○"}
                                    </span>
                                    At least 8 characters
                                  </div>
                                  <div
                                    className={`flex items-center text-sm ${
                                      values.password &&
                                      /[A-Z]/.test(values.password)
                                        ? "text-green-600"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    <span className="mr-2">
                                      {values.password &&
                                      /[A-Z]/.test(values.password)
                                        ? "✓"
                                        : "○"}
                                    </span>
                                    1 uppercase letter
                                  </div>
                                  <div
                                    className={`flex items-center text-sm ${
                                      values.password &&
                                      /[a-z]/.test(values.password)
                                        ? "text-green-600"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    <span className="mr-2">
                                      {values.password &&
                                      /[a-z]/.test(values.password)
                                        ? "✓"
                                        : "○"}
                                    </span>
                                    1 lowercase letter
                                  </div>
                                  <div
                                    className={`flex items-center text-sm ${
                                      values.password &&
                                      /[0-9]/.test(values.password)
                                        ? "text-green-600"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    <span className="mr-2">
                                      {values.password &&
                                      /[0-9]/.test(values.password)
                                        ? "✓"
                                        : "○"}
                                    </span>
                                    1 numeric character
                                  </div>
                                  <div
                                    className={`flex items-center text-sm ${
                                      values.password &&
                                      /[^A-Za-z0-9]/.test(values.password)
                                        ? "text-green-600"
                                        : "text-gray-500"
                                    }`}
                                  >
                                    <span className="mr-2">
                                      {values.password &&
                                      /[^A-Za-z0-9]/.test(values.password)
                                        ? "✓"
                                        : "○"}
                                    </span>
                                    1 special character
                                  </div>
                                </div>
                              </div>
                              {/* Confirm New Password */}
                              <InputWithLabel
                                className={
                                  errors.confirm_password &&
                                  touched.confirm_password
                                    ? ` input-error `
                                    : ` border `
                                }
                                idFromName="confirm_password"
                                label="Confirm New Password"
                                type={confirmPasswordType}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.confirm_password}
                                errors={
                                  errors.confirm_password &&
                                  touched.confirm_password
                                }
                                errorsText={errors.confirm_password}
                                icon={
                                  <p
                                    className="p-2 absolute top-1.5 right-0 rounded bg-transparent z-20"
                                    onClick={() => {
                                      setConfirmPasswordType(
                                        confirmPasswordType === "password"
                                          ? "text"
                                          : "password"
                                      );
                                    }}
                                  >
                                    {confirmPasswordType === "password" ? (
                                      <EyeSlash size="20" />
                                    ) : (
                                      <Eye size="20" />
                                    )}
                                  </p>
                                }
                              />
                              <div className="md:flex md:space-x-4 md:space-y-0 space-y-4 w-full">
                                {/* Country */}
                                <div className="md:w-1/3">
                                  <div
                                    className={`${
                                      errors.countryId && touched.countryId
                                        ? ` input-error `
                                        : ""
                                    } relative bg-white transition duration-300 rounded`}
                                  >
                                    <ReactSelect
                                      className={
                                        "text-black sm:text-base text-sm p-0"
                                      }
                                      id="country"
                                      placeholder="Country"
                                      options={countryArray}
                                      isLoading={countryLoading}
                                      getOptionValue={(countryArray) =>
                                        countryArray.name
                                      }
                                      value={
                                        countryArray?.length > 0 &&
                                        countryArray?.find((op) => {
                                          return op.id === values.countryId;
                                        })
                                      }
                                      onChange={(e) => {
                                        setFieldValue("country", e);
                                        setFieldValue("countryId", e?.id);
                                      }}
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          border: `1px solid ${
                                            errors.countryId &&
                                            touched.countryId
                                              ? "red"
                                              : "#0000003B"
                                          }`,
                                          borderRadius: "0.25rem",
                                          padding: "5px 4px",
                                          boxShadow: "none",
                                          "&:hover": {
                                            border: "1px solid #0000003B",
                                          },
                                        }),
                                      }}
                                    />
                                    <label
                                      htmlFor="country"
                                      className="absolute text-light_grey pointer-events-none sm:text-base text-sm bg-white duration-300 transform -translate-y-5 scale-75 top-2 origin-[0] px-2 peer-focus:px-2 peer-focus peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                    >
                                      Country
                                    </label>
                                  </div>
                                  {errors.countryId && touched.countryId ? (
                                    <>
                                      <InputError
                                        errorTitle={errors.countryId}
                                      />
                                    </>
                                  ) : null}
                                </div>
                                {/* Phone */}
                                <div className="md:w-2/3">
                                  <InputWithLabel
                                    className={
                                      errors.phone && touched.phone
                                        ? ` input-error `
                                        : ` border `
                                    }
                                    idFromName="phone"
                                    label="Mobile Number"
                                    type="number"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.phone}
                                    errors={errors.phone && touched.phone}
                                    errorsText={errors.phone}
                                  />
                                </div>
                              </div>
                              {/* Date of Birth */}
                              <div>
                                <div
                                  className={`${
                                    errors.dob && touched.dob
                                      ? ` input-error `
                                      : ` `
                                  } relative bg-white transition duration-300 rounded plus-number-inputs`}
                                >
                                  <DatePicker
                                    selected={values.dob}
                                    onChange={(date) =>
                                      setFieldValue("dob", new Date(date))
                                    }
                                    maxDate={new Date()}
                                    id="dob"
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText={"Select Date Of Birth"}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className={`border sm:text-base text-sm border-secondary_grey ${
                                      errors.dob && touched.dob
                                        ? "error-forms"
                                        : ""
                                    } rounded w-full px-3 py-2.5`}
                                  />
                                  <label
                                    htmlFor="dob"
                                    className="absolute text-light_grey pointer-events-none sm:text-base text-sm bg-white duration-300 transform -translate-y-5 scale-75 top-2 origin-[0] px-2 peer-focus:px-2 peer-focus peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                                  >
                                    Date Of Birth (DD/MM/YYYY)
                                  </label>
                                </div>
                                {errors.dob && touched.dob ? (
                                  <InputError errorTitle={errors.dob} />
                                ) : null}
                              </div>
                              {/* Gender */}
                              <div>
                                <label className="block sm:text-base text-sm">
                                  Gender
                                </label>
                                <div className="inline-flex items-center">
                                  <label
                                    className="relative flex items-center p-2 rounded-full cursor-pointer"
                                    htmlFor="male"
                                    data-ripple-dark="true"
                                  >
                                    <input
                                      name="gender"
                                      type="radio"
                                      value="male"
                                      className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-blue-gray-200 text-blue-500 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-blue-500 checked:before:bg-blue-500 hover:before:opacity-10"
                                      id="male"
                                      checked={values.gender === "male"}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <span className="absolute text-blue-500 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5"
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                      >
                                        <circle
                                          data-name="ellipse"
                                          cx="8"
                                          cy="8"
                                          r="8"
                                        ></circle>
                                      </svg>
                                    </span>
                                  </label>
                                  <label
                                    className="mt-px font-light text-gray-700 cursor-pointer sm:text-base text-sm select-none"
                                    htmlFor="male"
                                  >
                                    Male
                                  </label>
                                </div>
                                <div className="inline-flex items-center">
                                  <label
                                    className="relative flex items-center p-2 rounded-full cursor-pointer"
                                    htmlFor="female"
                                  >
                                    <input
                                      name="gender"
                                      type="radio"
                                      value="female"
                                      className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-blue-gray-200 text-blue-500 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-blue-500 checked:before:bg-blue-500 hover:before:opacity-10"
                                      id="female"
                                      checked={values.gender === "female"}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <span className="absolute text-blue-500 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5"
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                      >
                                        <circle
                                          data-name="ellipse"
                                          cx="8"
                                          cy="8"
                                          r="8"
                                        ></circle>
                                      </svg>
                                    </span>
                                  </label>
                                  <label
                                    className="mt-px font-light text-gray-700 cursor-pointer sm:text-base text-sm select-none"
                                    htmlFor="female"
                                  >
                                    Female
                                  </label>
                                </div>
                                {errors.gender && touched.gender ? (
                                  <InputError errorTitle={errors.gender} />
                                ) : null}
                              </div>
                              {/* from Singpass */}
                              {fromSingpass && <FromSingpass values={values} />}
                            </div>

                            {/*  Button */}
                            <button type="submit" className="btn-theme w-full">
                              REGISTER
                            </button>

                            {/* SingPass Button */}
                            <button
                              type="button"
                              className="w-full bg-red hover:bg-red-700 text-white font-medium py-2.5 px-4 rounded-md transition duration-300"
                              onClick={() => {
                                // Handle SingPass integration
                                // window.location.href = "/callback"; // Replace with actual SingPass URL
                              }}
                            >
                              Retrieve Myinfo with singpass
                            </button>

                            <div className="flex text-sm">
                              <p className="mr-1 font-light">
                                Already have an Account ?
                              </p>
                              <Link
                                to="/login"
                                className="cursor-pointer font-bold"
                              >
                                Login Now
                              </Link>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </section>
              <section className="hidden md:flex lg:flex xl:flex items-center">
                <img
                  src={SignUp}
                  alt="logo"
                  className="sm:max-w-fit lg:max-w-screen-sm"
                />
              </section>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Auth;
